<template>
  <div>
    <div
      class="d-flex justify-space-between grey--text text--darken-2 pb-1"
    >
      <v-badge
        class="font-weight-bold"
        color="error"
        inline
        :content="badgeContent"
        :value="showBadge"
      >
        <div class="d-flex">
          <span class="font-weight-bold text-body-2 pr-2">
            {{ label }}
          </span>
        </div>
      </v-badge>
      <slot name="actions"></slot>
    </div>
    <div class="font-weight-light text-body-2 black--text">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReferenceField',
  props: {
    label: {
      type: String,
      required: true,
    },
    badgeContent: {
      type: [String, Number],
      default: null,
    },
  },
  computed: {
    showBadge() {
      return !!this.badgeContent;
    },
  },
};
</script>
